// Decorative only, never interactive: no click handler and no cursor-pointer
// (per CLAUDE.md). Requires a `relative` parent to anchor against.
export function LastUsedTag() {
  return (
    <span className="pointer-events-none absolute -top-2 right-2 z-10 rounded-full bg-[#ff3b31] px-2 py-0.5 text-xs font-semibold text-white shadow-md ring-2 ring-background">
      Last used
    </span>
  );
}
